module.exports = __webpack_public_path__ + "media/outside-720.5b178f78.mp4";